<template>
  <transition name="fade" mode="out-in">
    <div :class="['repeatable-list', {'w3-show': repeatableGroupOpen}, {'w3-hide': !repeatableGroupOpen}]">
      <div if="draggableObject.children.length > 0">
        <transition name="fade" mode="out-in">
          <table :class="['searcher-results', 'w3-table', 'search']">
            <thead v-if="draggableObject.children && draggableObject.children.length > 0">
              <tr>
                <th
                  v-for="(header) in listHeader" :key="header.id" :class="header.type"
                >
                  {{ header.label }}
                </th>
                <th class="repeatableListButtons"></th>
              </tr>
            </thead>
            <tbody>
              <!-- repeateble group items -->
              <tr
                  v-for="(obj, objIndex) in draggableObject.children" :key="obj.id + '_' + objIndex"
                  :class="['resultat_taula',
                    {'modifying': modify && modifyIndex === objIndex},
                    {'disabled': modify && modifyIndex !== objIndex}
                  ]"
              >
                <template v-if="(!modify || modifyIndex !== objIndex)">
                  <td
                    v-for="(childObj, childObjIndex) in getObjChildren(obj.children, objIndex)" :key="childObjIndex" :class="getRequestDefinitionById(childObj.id).type"
                  >
                    <definition-repeatable-group-read-only
                      :definitionId="definitionId" :definition="getRequestDefinitionById(childObj.id)" :object="getRequestObjectByIdAndIndex(childObj.id, objIndex)"
                      :languageSelected="languageSelected" :index="objIndex" :moment="getMoment()" :showMultilanguage="false" :language="language"
                      :visualDefinition="visualDefinition" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
                      :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :hideLabel="true"
                    />
                  </td>
                </template>
                <template v-else-if="modifyIndex === objIndex">
                  <!-- Modify definition -->
                  <definition-obj v-for="reqDef in definition.children" :key="reqDef.id"
                    :id="reqDef.id"
                    :definitionId="definitionId"
                    :reqDef="reqDef"
                    :reqObj="getRequestObjectByIdAndIndex(reqDef.id, objIndex, true)"
                    :reqObjForAdd="object.children[objIndex]"
                    :requestObjectForAddModified="requestObjectForAddModified"
                    :content="definitionContent"
                    :modeView="getRepeatableGroupModeView(obj)"
                    :validateAddForm="validateModifyForm"
                    :repeatableGroupId="repeatableGroupId"
                    :languageSelected="languageSelected"
                    :index="objIndex"
                    :moment="getMoment()"
                    :definitionContentId="definitionContentId"
                    :parentRepeatableGroupCode="getRepeatableGroupCode(objIndex)"
                    :language="language"
                    :visualDefinition="visualDefinition"
                    :authorization="authorization"
                    :type="type"
                    :visuals="visuals"
                    :apiparams="apiparams"
                    :isTableObj="true"
                    @newLanguageSelected="newLanguageSelected"
                    @refreshDefinition="refreshDefinitionModifying"
                    @conditionalDefinitionChange="conditionalDefinitionChange"
                    @refreshDefinitionContent="refreshDefinitionContent"
                    @refreshConditionalFieldId="refreshConditionalFieldId"
                    class="item"
                  />
                  <!-- Definition Group Task Edit -->
                  <div v-if="definition.task && definition.task.length > 0" :class="[getDefinitionFieldClassTaskClass(), 'groupTasks']">
                    <definition-task
                      :definition="definition" :object="getRequestObjectByIdAndIndex(definition.id, objIndex)" :definitionContentId="definitionContentId" :repeatableGroupCode="getRepeatableGroupCode(objIndex)" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
                      location="edit" :repeatableGroupPresentation="repeatableGroupPresentation" :callTask="callTask"
                      @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent"
                    />
                  </div>
                </template>
                <td class="repeatableListButtons">
                  <div :class="['buttons', {'modify': modify && modifyIndex === objIndex}]">
                    <div class="language-buttons">
                      <template v-if="(route && route.query && route.query.code && !codeLoaded)">
                        <spinner-loading class="spinner-loading codeLoading" :line-size='2' :size='18' line-fg-color='#5dbecd' />
                      </template>
                      <template v-else>
                        <!-- multilanguage select -->
                        <definition-multilanguage v-if="!modify && definitionMultiLanguageGroup"
                          :definition="definitionMultiLanguageGroup" :object="object" :languageSelected="languageSelected" :language="language" :apiparams="apiparams"
                          @newLanguageSelected="newLanguageSelected"
                        />

                        <!-- remove button -->
                        <template v-if="!modify">
                          <button v-show="modifyIndex !== objIndex && !hideAdd && isEditable(definition, obj)" class="remove-item" @click="removeItem(objIndex)" v-tooltip="{content: getLang('delete'), delay: { show: 400, hide: 100 }}">
                            <transition name="fade" mode="out-in">
                              <span v-if="removeIndex !== objIndex"><i class="sherpa-icon icon-trash"></i></span>
                              <spinner-loading v-else class="spinner-loading" :size="19" :line-size="1" line-fg-color='#5dbecd' />
                            </transition>
                          </button>
                          <!-- modify button -->
                          <button class="modify-item" @click="modifyItem(obj, objIndex)" v-tooltip="{content: getLang('edit'), delay: { show: 400, hide: 100 }}">
                            <transition name="fade" mode="out-in">
                              <span v-if="modifyIndex !== objIndex"><i class="sherpa-icon icon-editar"></i></span>
                              <spinner-loading v-else class="spinner-loading" :size="18" :line-size="1" line-fg-color='#5dbecd' />
                            </transition>
                          </button>
                        </template>

                        <!-- modify button -->
                        <template v-if="modify && modifyIndex === objIndex">
                          <button class="modify-item cancel" @click="cancelModify($event)">
                            <transition name="fade" mode="out-in">
                              <span v-if="!validateModifyForm.validatingAdd"><i class="sherpa-icon icon-cerrar"></i></span>
                            </transition>
                          </button>
                          <button v-if="isEditable(definition, obj)" class="modify-item ok" @click="okModify($event)">
                            <transition name="fade" mode="out-in">
                              <span v-if="!validateModifyForm.validatingAdd"><i class="far fa-save"></i></span>
                              <spinner-loading v-else class="spinner-loading" :size="18" :line-size="1" line-fg-color='#5dbecd' />
                            </transition>
                          </button>
                        </template>
                      </template>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import DefinitionRepeatableGroupReadOnly from './repeatableGroupReadOnly'
import DefinitionMultilanguage from '../multilanguage'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../../language'

export default {
  name: 'definition-repeatable-list',
  props: [
    'draggableObject',
    'definition',
    'object',
    'requestObjectForAddModified',
    'languageSelected',
    'language',
    'apiparams',
    'definitionId',
    'definitionContentId',
    'definitionContent',
    'visualDefinition',
    'questions',
    'authorization',
    'type',
    'visuals',
    'repeatableGroupOpen',
    'repeatableGroupCode',
    'validateModifyForm',
    'repeatableGroupId',
    'repeatableGroupPresentation',
    'callTask',
    'route',
    'codeLoaded',
    'definitionMultiLanguageGroup',
    'hideAdd',
    'hideModify',
    'removeIndex',
    'modify',
    'modifyIndex'
  ],
  data () {
    return {
      listHeader: null
    }
  },
  components: {
    DefinitionRepeatableGroupReadOnly,
    DefinitionMultilanguage,
    DefinitionObj: () => import('../definitionObj.vue') // Webpack’s asynchronous import for recursivity components
  },
  beforeMount () {
    this.listHeader = this.getListHeaders(this.definition.children)
  },
  methods: {
    getListHeaders (lReqDef) {
      let result = []

      if (lReqDef) {
        for (let reqDef of lReqDef) {
          if (reqDef.type !== 'group' && reqDef.type !== 'conditional') {
            result.push(reqDef)
          } else {
            result = result.concat(this.getListHeaders(reqDef.children))
          }
        }
      }

      return result
    },
    getObjChildren (children, objIndex) {
      let result = []

      if (children) {
        for (let childObj of children) {
          if (this.getRequestObjectByIdAndIndex(childObj.id, objIndex)) {
            result.push(childObj)
          }
        }
      }

      return result
    },
    getRequestObjectByIdAndIndex (id, index) {
      return transport.methods.getRequestObjectById(id, [this.object.children[index]])
    },
    getRequestDefinitionById (id) {
      return transport.methods.getRequestDefinitionById(id, [this.definition])
    },
    getMoment () {
      return moment().valueOf()
    },
    getRepeatableGroupModeView (object) {
      let result
      if (object && object.editable === false) {
        result = 'lookup'
      } else {
        result = this.modeView
      }
      return result
    },
    getRepeatableGroupCode (index) {
      var reqObj = this.getRequestObjectByIdAndIndex(this.definition.id, index)
      return transport.methods.getRepeatableGroupCode(reqObj, this.definition)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    refreshDefinitionModifying (object) {
      this.$emit('refreshDefinitionModifying', object)
    },
    conditionalDefinitionChange (conditionalFieldId, newReqObj) {
      this.$emit('conditionalDefinitionChange', conditionalFieldId, newReqObj)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    refreshConditionalFieldId (newReqObj) {
      this.$emit('refreshConditionalFieldId', newReqObj)
    },
    getDefinitionFieldClassTaskClass () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      return definition.tasks
    },
    refreshDefinition (object) {
      this.$emit('refreshDefinition', object)
    },
    isEditable (definition, repeatableObject) {
      let result = false

      if (repeatableObject && repeatableObject.editable === false) {
        result = false
      } else {
        result = false

        if (definition.children) {
          for (var i = 0; i < definition.children.length && !result; i++) {
            result = result || transport.methods.isEditable(this.modeView, definition.children[i], repeatableObject)
            if (!result) {
              result = result || this.isEditable(definition.children[i], repeatableObject)
            }
          }
        }
      }

      return result
    },
    removeItem (index) {
      this.$emit('removeItem', index)
    },
    getLang (key) {
      return language(this.language, key)
    },
    modifyItem (obj, index) {
      this.$emit('modifyItem', obj, index)
    },
    okModify (event) {
      this.$emit('okModify', event)
    },
    cancelModify (event) {
      this.$emit('cancelModify', event)
    }
  }
}
</script>

<style lang="scss">
.repeatable-list {
  .definitionObj {
    .label {
      display: none  !important;
    }
  }
  table {
    &.searcher-results {
      thead > tr > th.repeatableListButtons {
        width: 85px;
      }
      tbody > tr {
        &.disabled {
          background-color: #f8f8f8 !important;
        }
        &.modifying,
        &:hover {
          background-color: #efefef;
        }

        > td {
          vertical-align: top;
        }
      }
    }
  }
  button.remove-item,
  button.modify-item {
    padding: 0;
    margin: 7px 5px 1px;
    height: initial;

    &.cancel {
      margin-top: 9px;

      i {
        color: #ff7643;
        font-size: 15px;
      }
    }

    &.ok {
      background-color: transparent;

      span {
        i {
          color: #ff7643;
          font-size: 20px;
        }
      }
    }

    &.cancel:hover,
    &.ok:hover {
      span {
        i {
          color: #d42e12;
          transition: all 0.2s ease-in;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/repeatableGroup/repeatableList.vue